// extracted by mini-css-extract-plugin
module.exports = {"summary":"_3fe76d0","panel":"_5665720","panelOddsboost":"_3896065"};